import { AccessGrant, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { visitorsGroupsVar } from 'state/vars';

export const setVisitorsGroupsAction = (visitorsGroups: VisitorGroup[]) => {
  visitorsGroupsVar(visitorsGroups);
};

const updateAccessGrant = (visitorGroup: VisitorGroup, updatedAccessGrant: AccessGrant) =>
  visitorGroup.accessGrants.map((accessGrant) => {
    if (accessGrant.id === updatedAccessGrant.id) {
      return { ...accessGrant, doors: updatedAccessGrant.doors };
    }
    return accessGrant;
  });

export const updateAccessGrantsAction = (updatedAccessGrant: AccessGrant) => {
  const currentVisitorGroups = visitorsGroupsVar();
  const updatedVisitorGroups = currentVisitorGroups.map((visitorGroup) => ({
    ...visitorGroup,
    accessGrants: updateAccessGrant(visitorGroup, updatedAccessGrant)
  }));

  visitorsGroupsVar(updatedVisitorGroups);
};

export const setAccessGrantsForGroupAction = (accessGrantsForGroup: VisitorGroup) => {
  const currentVisitorGroups = visitorsGroupsVar();
  const updatedVisitorGroups: VisitorGroup[] = (currentVisitorGroups as VisitorGroup[]).map((visitorGroup) => {
    if (visitorGroup.id === accessGrantsForGroup.id)
      return {
        ...visitorGroup,
        accessGrants: accessGrantsForGroup.accessGrants
      };
    return {
      ...visitorGroup
    };
  });
  visitorsGroupsVar(updatedVisitorGroups);
};
